import PickupInStoreSearch from '@molecules/PickupInStoreSearch/PickupInStoreSearch';
import useFinishPickUpSubmission from '@molecules/PickUpInStoreSelector/useFinishPickUpSubmission';
import useCustomRouter from '@hooks/useCustomRouter';
import { useMemo } from 'react';
import paths from '@constants/paths';

export interface PickupInStoreSelectorProps {
  title: string;
  afterSubmit: () => void;
  onCancel?: () => void;
}

const PickUpInStoreSelector = ({ title, afterSubmit, onCancel }: PickupInStoreSelectorProps) => {
  const router = useCustomRouter();
  const isCheckout = useMemo(() => router.pathname === paths.CHECKOUT, [router.pathname]);
  const finishPickUpSubmission = useFinishPickUpSubmission(isCheckout ? 'checkout' : 'deliveryPicker', afterSubmit);
  return <PickupInStoreSearch title={title} finishPickUpSubmission={finishPickUpSubmission} onCancel={onCancel} />;
};

export default PickUpInStoreSelector;
